export default "__VITE_ASSET__78d0b937__"